export const mbToBytes = (mb: number): number => {
  const bytesInMB = 1024 * 1024; // 1 MB = 1024 KB, 1 KB = 1024 bytes
  return mb * bytesInMB;
};

export const bytesToMB = (bytes: number): number => {
  return parseFloat((bytes / 1024 / 1024).toFixed(2));
};

type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

export const getEntries = <T extends object>(obj: T) =>
  Object.entries(obj) as Entries<T>;
